module.exports = __webpack_public_path__ + "static/media/subeditor.928099fc.ico";